/*
  Carnevore Mountain header: hides the header while scrolling down and brings it back on scroll up.
  Uses Dawn's section-header classes (shopify-section-header-sticky / -hidden / animate / scrolled-past-header).
  Other scripts can keep it hidden for one scroll by dispatching 'preventHeaderReveal' on the element.
*/
if (!customElements.get('cm-sticky-header')) {
  class CmStickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.headerBounds = {};

      this.setHeaderHeight = () => {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      };
      this.onScroll = this.onScroll.bind(this);
      this.onPreventReveal = () => {
        this.preventReveal = true;
      };

      this.setHeaderHeight();
      this.mobileQuery = window.matchMedia('(max-width: 990px)');
      this.mobileQuery.addEventListener('change', this.setHeaderHeight);
      this.addEventListener('preventHeaderReveal', this.onPreventReveal);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    disconnectedCallback() {
      if (!this.header) return;
      this.mobileQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.onPreventReveal);
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const pastHeader = scrollTop > this.headerBounds.bottom;

      if (scrollTop > this.currentScrollTop && pastHeader) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(() => this.hide());
      } else if (scrollTop < this.currentScrollTop && pastHeader) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(() => this.reveal());
        } else {
          window.clearTimeout(this.revealTimer);
          this.revealTimer = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.querySelectorAll('header-menu').forEach((menu) => menu.close && menu.close());
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('cm-sticky-header', CmStickyHeader);
}
